import { defineComponent as _defineComponent } from 'vue'
import QuoteRequestCounter from "./QuoteRequestCounter.vue";
  import BuilderMobileHeader from "@/components/builder/BuilderMobileHeader.vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import HeaderWithEstateLogo from "../ui/HeaderWithEstateLogo.vue";
  import { LotInterface } from "@/types/LotInterface";
  import { computed } from "vue";
  import Stepper from "../ui/Stepper.vue";
  import store from "@/store";
  import { CustomizeHouseStepsEnum } from "@/enums/CustomizeHouseSteps";
  import { useIsDesktop } from "@/features/useIsDesktop";

  interface Props {
    estate: EstateInterface;
    builderLogo: string;
    isReviewQuote?: boolean;
    skipStepIndex?: number;
  }

export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderHeader',
  props: {
    estate: {},
    builderLogo: {},
    isReviewQuote: { type: Boolean },
    skipStepIndex: {}
  },
  emits: ["onRequestQuotes"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;
  const { isDesktop } = useIsDesktop(990);
  const onRequestQuotes = () => {
    emits("onRequestQuotes");
  };
  const selectedQuote = computed(() => {
    return store.getters["builder/getSelectedSelection"];
  });

  
const __returned__ = { props, emits, isDesktop, onRequestQuotes, selectedQuote, QuoteRequestCounter, BuilderMobileHeader, get EstateInterface() { return EstateInterface }, HeaderWithEstateLogo, get LotInterface() { return LotInterface }, computed, Stepper, get store() { return store }, get CustomizeHouseStepsEnum() { return CustomizeHouseStepsEnum }, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})